const axios = require('axios');

class HttpUtils {
  http;

  constructor() {
    this.http = axios.create({
      proxy: false
    })
  }

  get = (url, params = {}, headers = {}) => {
    return new Promise((resolve, reject) => {
      this.http.get(url, { params, headers: { ...headers, 'authorization': localStorage['token'], server: localStorage['server'] } })
        .then(function (response) {
          // handle success
          resolve(response);
        })
        .catch((error) => {
          // handle error
          this.onError(error, reject);
        })
        .then(function () {
          // always executed
        });
    });
  }

  put = (url, body = {}, headers = {}) => {
    return new Promise((resolve, reject) => {
      this.http.put(url, body, { headers: { ...headers, 'authorization': localStorage['token'], server: localStorage['server'] } })
        .then(function (response) {
          // handle success
          resolve(response);
        })
        .catch((error) => {
          // handle error
          this.onError(error, reject);
        })
        .then(function () {
          // always executed
        });
    });
  }

  post = (url, body = {}, headers = {}) => {
    return new Promise((resolve, reject) => {
      this.http.post(url, body, { headers: { ...headers, 'authorization': localStorage['token'], server: localStorage['server'] } })
        .then(function (response) {
          // handle success
          resolve(response);
        })
        .catch((error) => {
          // handle error
          this.onError(error, reject);
        })
        .then(function () {
          // always executed
        });
    });
  }

  delete = (url, params = {}, headers = {}) => {
    return new Promise((resolve, reject) => {
      this.http.delete(url, { params, headers: { ...headers, 'authorization': localStorage['token'], server: localStorage['server'] } })
        .then(function (response) {
          // handle success
          resolve(response);
        })
        .catch((error) => {
          // handle error
          this.onError(error, reject);
        })
        .then(function () {
          // always executed
        });
    });
  }

  onError = (error, reject) => {
    if ([401, 403].includes(error.response.status)) {
      localStorage.removeItem('token');
      window.location.reload();
    } else {
      reject();
    }
  }
}

export default new HttpUtils();
